import { FormattedMessage } from 'react-intl';

export const WearRegularityTitle = () => (
  <span data-testid="wear-regularity-vp-title">
    <FormattedMessage id="vp.wearRegularity.title" />
  </span>
);